import React from "react";
import { Link } from "react-router-dom";

export default function LeaveShowGrid({ showData }) {
  return (
    <div className="row g-4 mb-2">
      <div className="col-md-4">
        <Link to="/user/emp" className="text-decoration-none">
          <div className="modern-card h-100 border-0" style={{ background: '#f0f4ff', borderRadius: '24px', padding: '24px', transition: 'transform 0.2s ease' }}>
            <div className="d-flex justify-content-between mb-3">
              <span style={{ fontSize: '15px', fontWeight: 600, color: '#0b6e9cff' }}>{showData.firstHeader}</span>
              <div style={{ background: '#0b6e9c1a', borderRadius: '14px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-people" style={{ color: '#0b6e9cff', fontSize: '20px' }}></i>
              </div>
            </div>
            <h2 style={{ fontSize: '32px', fontWeight: 700, margin: '0', color: '#0a5274ff' }}>{showData.firstCount}</h2>
            <div className="mt-2" style={{ fontSize: '12px', color: '#0b6e9cff', opacity: 0.8 }}>
              Total registered employees
            </div>
          </div>
        </Link>
      </div>

      <div className="col-md-4">
        <Link to="/user/attendence" className="text-decoration-none">
          <div className="modern-card h-100 border-0" style={{ background: '#e3fdd96c', borderRadius: '24px', padding: '24px', transition: 'transform 0.2s ease' }}>
            <div className="d-flex justify-content-between mb-3">
              <span style={{ fontSize: '15px', fontWeight: 600, color: 'green' }}>{showData.secondHeader}</span>
              <div style={{ background: '#e3fdd9ff', borderRadius: '14px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-person-check" style={{ color: 'green', fontSize: '20px' }}></i>
              </div>
            </div>
            <h2 style={{ fontSize: '32px', fontWeight: 700, margin: '0', color: '#256b09ff' }}>{showData.secondCount}</h2>
            <div className="mt-2" style={{ fontSize: '12px', color: 'green', opacity: 0.8 }}>
              Present today
            </div>
          </div>
        </Link>
      </div>

      <div className="col-md-4">
        <Link to="/user/todayLeaves" className="text-decoration-none">
          <div className="modern-card h-100 border-0" style={{ background: '#fde9cf44', borderRadius: '24px', padding: '24px', transition: 'transform 0.2s ease' }}>
            <div className="d-flex justify-content-between mb-3">
              <span style={{ fontSize: '15px', fontWeight: 600, color: 'orange' }}>{showData.thirdHeader}</span>
              <div style={{ background: '#fde9cf', borderRadius: '14px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-person-x" style={{ color: 'orange', fontSize: '20px' }}></i>
              </div>
            </div>
            <h2 style={{ fontSize: '32px', fontWeight: 700, margin: '0', color: '#975d10ff' }}>{showData.thirdCount}</h2>
            <div className="mt-2" style={{ fontSize: '12px', color: 'orange', opacity: 0.8 }}>
              Absent today
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

